const starsElm = document.querySelectorAll<HTMLDivElement>(
  '.js-open-reviews-tab'
);
const activeClassName = 'js-active';
const tabsContainerClassName = '.js-tabs-container';
const tabsContainerElm = document.querySelector<HTMLDivElement>(
  tabsContainerClassName
);
const ratingsTab = document.querySelector<HTMLButtonElement>(
  '[name="tab-reviews"]'
);

const ratingsTabContent =
  document.querySelector<HTMLDivElement>('#tab-reviews');

if (ratingsTab && ratingsTabContent) {
  starsElm?.forEach((elm) => {
    elm.addEventListener('click', () => {
      tabsContainerElm?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      deactiveTabs();
      ratingsTab.classList.add(activeClassName);
      ratingsTabContent.classList.add(activeClassName);
    });
  });
}

const deactiveTabs = () => {
  const activeTabs = tabsContainerElm?.querySelectorAll('.js-active');
  activeTabs?.forEach((tab) => {
    tab.classList.remove(activeClassName);
  });
};
